import React from 'react';

import NewSpaceDescribePanel from '../shared/NewSpaceDescribePanel';
import SettingsBackButton from '../shared/SettingsBackButton';
import { SETTINGS_MODAL_TITLE_CLASS } from '../shared/settingsModalChrome';
import { Modal } from './Modal';
import { ModalBody } from './ModalBody';
import { ModalContent } from './ModalContent';
import { ModalTopBar } from './ModalTopBar';

// Same chrome as NewWorkspaceModal, which this replaces as the "Create a group" step
// when AI setup is enabled. The Create pill floats from inside the panel so it can read
// the form's state.
const NewSpaceDescribeModal = ({ onClose, onSpaceSetupStarted, workspaceUrlForWorkspace }) => {
  return (
    <Modal onClose={onClose} className="rounded-2xl" showClose={false}>
      <SettingsBackButton onClick={onClose} />
      <ModalBody className="h-full">
        <ModalTopBar className="!pb-0">
          <span className={SETTINGS_MODAL_TITLE_CLASS}>New Space</span>
        </ModalTopBar>
        <ModalContent className="min-h-0 md:!px-5">
          <NewSpaceDescribePanel onSpaceSetupStarted={onSpaceSetupStarted} workspaceUrlForWorkspace={workspaceUrlForWorkspace} />
        </ModalContent>
      </ModalBody>
    </Modal>
  );
};

export default NewSpaceDescribeModal;
